import styled from "styled-components";

export const StyledSectionButtonsBorder = styled.div`
  border-right: 1px dashed;
  border-right-color: ${({ theme }) => theme.color.black};
  margin-left: 0.3rem;
`;
